/* eslint-disable complexity */
(function () {
    'use strict';

    function main() {
        var searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        var criteria;

        var searchResultsController = {
            init: function () {
                criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                searchResultsController.initPagedResults();
                searchResultsPage.find('[data-phone-summary]').dotdotdot({
                    watch: 'window',
                    height: 40
                });

                searchResultsPage
                    .find('[data-widen-result]')
                    .off('click')
                    .click(function (e) {
                        WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                        e.preventDefault();
                        var id = wo$(this).data('widen-result');
                        var removeAll = id === 'remove-all';
                        const resetMap = {
                            data: () => {
                                criteria.minData = null;
                            },
                            brands: () => {
                                criteria.brands = [];
                            },
                            phones: () => {
                                criteria.models = [];
                            },
                            os: () => {
                                criteria.operatingSystems = [];
                            },
                            suppliers: () => {
                                criteria.suppliers = [];
                            },
                            networks: () => {
                                criteria.networks = [];
                            },
                            screen: () => {
                                criteria.minScreen = null;
                                criteria.maxScreen = null;
                            },
                            camera: () => {
                                criteria.camera = null;
                            },
                            spend: () => {
                                criteria.minSpend = null;
                                criteria.maxSpend = null;
                            },
                            upfront: () => {
                                criteria.maxUpfront = null;
                            },
                            priceTypes: () => {
                                criteria.priceTypes = [];
                            },
                            released: () => {
                                criteria.released = null;
                            },
                            keyword: () => {
                                criteria.search = null;
                            },
                            planType: () => {
                                criteria.planType = null;
                            },
                            '5g': () => {
                                criteria.show5G = null;
                            },
                            esim: () => {
                                criteria.showESim = null;
                            },
                            editorspicks: () => {
                                criteria.showEditorsPicksOnly = null;
                            },
                            bluetick: () => {
                                criteria.showTelstraBlueTickOnly = null;
                            },
                            optuspick: () => {
                                criteria.optusRegionalPickOnly = null;
                            },
                            singlePhonePerBrand: () => {
                                criteria.singlePhonePerBrand = null;
                            },
                            sort: () => {
                                criteria.sortExpression = null;
                                criteria.sortAscending = true;
                            }
                        };
                        const keysToReset = removeAll ? Object.keys(resetMap) : [id];

                        keysToReset.forEach(key => {
                            const resetFn = resetMap[key];
                            if (typeof resetFn === 'function') resetFn();
                        });
                        WhistleOut.scrollTo(0);
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Widen', criteria: criteria });
                    });
            },

            toggleLoadMoreButtonVisbility: function () {
                var current = searchResultsPage.find('[data-current]:last').data('current');
                var total = searchResultsPage.find('[data-results-count]:last').data('results-count');
                if (current >= total) {
                    searchResultsPage.find('#load-more').hide();
                } else {
                    searchResultsPage.find('#load-more').show();
                }
            },

            initPagedResults: function () {
                searchResultsController.toggleLoadMoreButtonVisbility();

                searchResultsPage
                    .find('#load-more button')
                    .off('click')
                    .click(function () {
                        var current = searchResultsPage.find('[data-current]:last').data('current');
                        var queryString = WhistleOut.MobilePhones.generatePhonesQueryString(criteria);
                        searchResultsPage.find('#load-more button .fa-spinner').show();
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        wo$.ajax({
                            url: criteria.pagedResultsAjaxUrl + '?' + queryString + '&current=' + current,
                            type: 'GET',
                            success: function (result) {
                                var $results = wo$('div.results-list');
                                $results.append(result);
                                $results.find('[data-phone-summary]').dotdotdot({
                                    watch: 'window',
                                    height: 40
                                });
                                //searchResultsController.initGallery();
                                WhistleOut.applyPopover($results);
                                searchResultsPage.find('#load-more button .fa-spinner').hide();
                                wo$('[data-enable-when-ready]').removeAttr('disabled');
                                searchResultsController.toggleLoadMoreButtonVisbility();
                            },
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            error: function () {}
                        });
                    });
            }
        };

        searchResultsController.init();
        WhistleOut.notifications.add(function (notification) {
            if (notification === 'SearchResultsRendered') {
                searchResultsController.init();
            }
        });
    }

    WhistleOut.initModule(import.meta.url, main);
})();
